import React from "react";
import { IconSpinner } from "@wrstudios/icons";
import { Container } from "./styled/loading-spinner";

function LoadingSpinner() {
  return React.createElement(Container, null, React.createElement(IconSpinner, null));
}

export default LoadingSpinner;